var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "debug-wrapper",
      on: {
        mouseenter: function ($event) {
          _vm.showJsonLink = true
        },
        mouseleave: function ($event) {
          _vm.showJsonLink = false
        },
      },
    },
    [
      _vm.showJsonLink
        ? _c("div", { staticClass: "debug-meta" }, [
            _c("span", { staticClass: "debug-timestamp" }, [
              _vm._v(_vm._s(_vm.getFormattedTimestamp())),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "show-json-link",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.openPayloadModal.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Show JSON")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "debug-badge" }, [
        _vm._v("\n        DEBUG MESSAGE\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "debug-header",
          class: {
            "custom-debug": _vm.isCustomDebug() || _vm.isAIAssistantType(),
            "error-debug": _vm.isErrorType(),
            "warning-debug": _vm.isWarningType(),
          },
        },
        [
          _c(
            "div",
            { staticClass: "debug-icon-wrapper" },
            [
              _vm.isCustomDebug() || _vm.isAIAssistantType()
                ? _c("span", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(_vm.getAIAssistantIcon())),
                  ])
                : _c("BlockIconPreview", {
                    attrs: { blockType: _vm.getBlockType() },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "debug-header-title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.getBlockNameFromPayload()) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showPayloadModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Chatbot Debug - Detaylı Görünüm",
                "show-footer": false,
                xlarge: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.showPayloadModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "payload-viewer" }, [
                _vm.getChatbotId() ||
                _vm.getChatbotName() ||
                _vm.getBoardVersion() ||
                _vm.getStoryId()
                  ? _c("div", { staticClass: "payload-section" }, [
                      _c("h3", [_vm._v("🤖 Chatbot Senaryo Bilgileri")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-grid" }, [
                        _vm.getChatbotId()
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Chatbot ID:"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.getChatbotId())),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getChatbotName()
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Chatbot Adı:"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.getChatbotName())),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getBoardVersion()
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Chatbot Version:"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.getBoardVersion())),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getStoryId()
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Story ID:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "value link-value",
                                  attrs: {
                                    href: _vm.getStoryUrl(),
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.getStoryId()) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getBlockId() !== "N/A"
                  ? _c("div", { staticClass: "payload-section" }, [
                      _c("h3", [_vm._v("🎯 Block Bilgileri")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-grid" }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Tip:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.getBlockType())),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Block ID:"),
                          ]),
                          _vm._v(" "),
                          _vm.getBlockUrl()
                            ? _c(
                                "a",
                                {
                                  staticClass: "value link-value",
                                  attrs: {
                                    href: _vm.getBlockUrl(),
                                    target: "_blank",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.getBlockId()) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.getBlockId())),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("İsim:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.getBlockNameFromPayload())),
                          ]),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.getPayload()
                  ? _c(
                      "div",
                      { staticClass: "payload-section" },
                      [
                        _c("h3", [_vm._v("📦 Payload")]),
                        _vm._v(" "),
                        _c("vue-json-pretty", {
                          attrs: { data: _vm.getPayload(), deep: 3 },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.getStateInfo()
                  ? _c(
                      "div",
                      { staticClass: "payload-section" },
                      [
                        _c("h3", [_vm._v("🔄 State Bilgileri")]),
                        _vm._v(" "),
                        _c("vue-json-pretty", {
                          attrs: { data: _vm.getStateInfo(), deep: 3 },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.getRuntimeInfo()
                  ? _c(
                      "div",
                      { staticClass: "payload-section" },
                      [
                        _c("h3", [_vm._v("⚙️ Runtime Bilgileri")]),
                        _vm._v(" "),
                        _c("vue-json-pretty", {
                          attrs: { data: _vm.getRuntimeInfo(), deep: 3 },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.getChatbotInfo()
                  ? _c(
                      "div",
                      { staticClass: "payload-section" },
                      [
                        _c("h3", [_vm._v("🤖 Chatbot Bilgileri")]),
                        _vm._v(" "),
                        _c("vue-json-pretty", {
                          attrs: { data: _vm.getChatbotInfo(), deep: 3 },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "payload-section" },
                  [
                    _c("h3", [_vm._v("📋 Tüm Payload (Raw JSON)")]),
                    _vm._v(" "),
                    _c("vue-json-pretty", {
                      attrs: { data: _vm.getFullPayload(), deep: 3 },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }